// Cookiebot consent management integration
declare global {
  interface Window {
    Cookiebot?: any;
  }
}

/**
 * Inject Cookiebot script into the page
 * @param domainGroupId - Cookiebot domain group ID (UUID)
 */
const injectCookiebotScript = (domainGroupId: string): void => {
  // Check if Cookiebot is already initialized
  if (window.Cookiebot || document.getElementById('Cookiebot')) {
    console.log('Cookiebot already initialized');
    return;
  }

  // Inject Cookiebot script
  const script = document.createElement('script');
  script.id = 'Cookiebot';
  script.src = 'https://consent.cookiebot.com/uc.js';
  script.setAttribute('data-cbid', domainGroupId);
  script.setAttribute('data-blockingmode', 'auto');
  script.type = 'text/javascript';
  script.async = true;
  document.head.appendChild(script);

  console.log('Cookiebot initialized with domain group ID:', domainGroupId);
};

/**
 * Initialize Cookiebot consent management (deferred for better FCP)
 * @param domainGroupId - Cookiebot domain group ID (UUID)
 */
export const initializeCookiebot = (domainGroupId: string): void => {
  if (!domainGroupId || domainGroupId.length < 30) {
    console.warn('Invalid Cookiebot domain group ID:', domainGroupId);
    return;
  }

  // Defer Cookiebot loading until after initial render to improve FCP
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => injectCookiebotScript(domainGroupId), { timeout: 2000 });
  } else {
    setTimeout(() => injectCookiebotScript(domainGroupId), 2000);
  }
};
